const threePlOrders = {
  loading: true,
  detailsLoading: true,
  listLoading: {},
  opened: '',
  list: [],
  hasActiveFilters: false,
  locations: ['Adelaide', 'Brisbane', 'Cairns', 'Melbourne', 'Sydney'],
  statusFiler: {},
  searchFilters: {
    search: '',
    location: '',
  },
  statusFilerChecked: {},
}
const ThreePlOrdersReducer = function (state = threePlOrders, action) {
  switch (action.type) {
    case 'TOGGLE_THREE_PL_ORDER_LIST_LOADING': {
      return {
        ...state,
        listLoading: {
          ...state.listLoading,
          [action.key]: action.value,
        },
      }
    }
    case 'TOGGLE_THREE_PL_ORDERS_LOADING': {
      return {
        ...state,
        loading: action.value,
      }
    }
    case 'TOGGLE_THREE_PL_ORDER_LOADING': {
      return {
        ...state,
        detailsLoading: action.value,
      }
    }
    case 'SET_3PL_MY_ORDERS_SEARCH_FILTERS': {
      return {
        ...state,
        searchFilters: { ...state.searchFilters, [action.key]: action.payload },
      }
    }

    case 'SELECT_THREE_PL_ORDER': {
      return {
        ...state,
        opened: action.order,
      }
    }

    case 'TOGGLE_THREE_PL_ORDER_FILTERS': {
      return {
        ...state,
        statusFiler: action.value,
      }
    }

    case 'SET_THREE_PL_ORDER_FILTERS': {
      return {
        ...state,
        statusFiler: action.value,
      }
    }

    case 'SET_ACTIVE_THREE_PL_ORDER_FILTERS': {
      return {
        ...state,
        statusFilerChecked: action.value,
      }
    }

    case 'TOGGLE_ACTIVE_THREE_PL_ORDER': {
      return {
        ...state,
        hasActiveFilters: action.value,
      }
    }

    case 'UPDATE_THREE_PL_ORDERS': {
      return {
        ...state,
        list: action.list,
      }

      // let newList = {}
      // Object.entries(action.list).forEach(([key, value]) => (newList[key] = { ...state.list[key], ...value }))
      // return {
      //   ...state,
      //   list: {
      //     ...state.list,
      //     ...newList,
      //   },
      // }
    }
    default: {
      return state
    }
  }
}

export default ThreePlOrdersReducer
